import React, { useRef } from "react";
import {
	Card,
	CardBody,
	CardTitle,
	Row,
	Col,

} from 'reactstrap';
import PerfectScrollbar from 'react-perfect-scrollbar';
import ReactGA from "react-ga4";
import IframeResizer from '@iframe-resizer/react'

// import {
// 	TrainingMaterialsViewMobile
// } from '../../components/training/';

class MobileDocuchat extends React.Component {

	constructor(props) {
    super(props);

		this.state = {
      authToken: "",
      height: "540px",
      messageData: []
	  };

    this.iframeRef = React.createRef();

  }

	componentDidMount() {
		ReactGA.pageview(window.location.pathname);

		// const query = new URLSearchParams(this.props.location.search);
    // const token = query.get('token')
    // console.log("token: "+token)//123
    //
    // if (token) {
    //   if (token.length>0) {
    //     console.log("authToken: "+token)
    //     this.setState({authToken:token});
    //   }
    // }

	}

  componentWillUnmount() {
  }

  onResized = (data) => this.setState({ messageData: data })

  onMessage = (data) => {
    this.setState({ messageData: data })
    alert(`Message from frame ${data.iframe.id}: ${data.message}`)
    this.iframeRef.current.sendMessage('Hello back from the parent page')
  }

	render() {
		return (
			<div>
				<Row>
          <Col md="12">
						{
							// <IframeResizer
							// 	license="GPLv3"
							// 	log
							// 	forwardRef={this.iframeRef}
							// 	inPageLinks
							// 	onMessage={this.onMessage}
							// 	onResized={this.onResized}
							// 	src="https://app.docuchat.io/chat/embed/f49b8b7c-8383-4d8a-8e54-ced4840b0c25"
							// 	style={{ width: '100%', height: '100vh', border: 0 }}
							// />
						}
						{
							// <IframeResizer
	            //   license="GPLv3"
	            //   log
	            //   forwardRef={this.iframeRef}
	            //   inPageLinks
	            //   onMessage={this.onMessage}
	            //   onResized={this.onResized}
	            //   src="https://www.chatbase.co/chatbot-iframe/Xrf_L2ARmOTDea9Ua9c5U"
	            //   style={{ width: '100%', height: '100vh', border: 0 }}
	            // />
						}
						{
							<div style={{ width: '100%', height: '100vh', backgroundColor: "#000" }}>
								<div style={{ width: '100%', height: "80%" }}>
									<iframe
									    src="https://www.chatbase.co/chatbot-iframe/Xrf_L2ARmOTDea9Ua9c5U"
									    width="100%"
											height="100%"
									    frameborder="0"
									></iframe>
								</div>
							</div>
						}

          </Col>
				</Row>
			</div>
		);
	}
}

export default MobileDocuchat;
